/** Digits-only key for comparing phones across formats, e.g. (555) 123-4567 vs 5551234567. */
export const normalizeAlternateContactPhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  if (digits.length >= 10) {
    return digits.slice(-10);
  }
  return digits;
};

export const normalizeAlternateContactEmail = (email) =>
  String(email || '').trim().toLowerCase();

/**
 * Finds duplicate alternate contact phone/email values within one patient's list.
 */
export const findDuplicateAlternateContacts = (agents) => {
  const phoneCounts = new Map();
  const emailCounts = new Map();
  const duplicatePhones = new Set();
  const duplicateEmails = new Set();

  (agents || []).forEach((agent) => {
    if (!agent) {
      return;
    }
    const phoneKey = normalizeAlternateContactPhone(agent.agent_sms);
    if (phoneKey) {
      const count = (phoneCounts.get(phoneKey) || 0) + 1;
      phoneCounts.set(phoneKey, count);
      if (count > 1) {
        duplicatePhones.add(phoneKey);
      }
    }
    const emailKey = normalizeAlternateContactEmail(agent.agent_email);
    if (emailKey) {
      const count = (emailCounts.get(emailKey) || 0) + 1;
      emailCounts.set(emailKey, count);
      if (count > 1) {
        duplicateEmails.add(emailKey);
      }
    }
  });

  return {
    hasDuplicates: duplicatePhones.size > 0 || duplicateEmails.size > 0,
    duplicatePhones: Array.from(duplicatePhones),
    duplicateEmails: Array.from(duplicateEmails),
  };
};

/**
 * i18n key for the first duplicate issue found (phone checked before email).
 */
export const getAlternateContactDuplicateErrorKey = (agents) => {
  const { duplicatePhones, duplicateEmails } = findDuplicateAlternateContacts(
    agents
  );
  if (duplicatePhones.length > 0) {
    return 'Toast.Error.DuplicateAlternateContactPhone';
  }
  if (duplicateEmails.length > 0) {
    return 'Toast.Error.DuplicateAlternateContactEmail';
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/alternateContactDuplicates.js